angular.module('gym.pos').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.pos.deliveries', {
    url: '/deliveries',
    template: require('templates/gyms/pos/deliveries/deliveries.html.slim')
  });
}]);
